module.exports = __webpack_public_path__ + "img/firma1.9cd18416.png";